import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ConfigProvider, Spin } from "antd";
import { AuthProvider } from "./context/AuthContext";
import { AppContextProvider, useAppContext } from "./context/AppContext";
import PrivateRoute from "./components/PrivateRoute";

import Login from "./pages/Login/Login";
import ForgotPassword from "./pages/Login/ForgotPassword";
import ResetPassword from "./pages/Login/ResetPassword";
import Home from "./pages/Home/Home";
import Attendance from "./pages/Attendance/Attendance";
import Leave from "./pages/Leave/Leave";
import WFH from "./pages/WFH/WFH";
import Holidays from "./pages/Holidays/Holidays";
import Policies from "./pages/Policies/Policies";
import PolicyView from "./pages/Policies/PolicyView";
import Reimbursement from "./pages/Reimbursement/Reimbursement";
import Overtime from "./pages/Overtime/Overtime";

const GlobalLoader = () => {
  const { loading } = useAppContext();
  if (!loading) return null;
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(255,255,255,0.5)", zIndex: 2000, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <Spin size="large" />
    </div>
  );
};

function App() {
  return (
    <ConfigProvider theme={{ token: { colorPrimary: "#4F46E5" } }}>
      <AppContextProvider>
        <AuthProvider>
          <GlobalLoader />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
              <Route path="/attendance" element={<PrivateRoute><Attendance /></PrivateRoute>} />
              <Route path="/leave" element={<PrivateRoute><Leave /></PrivateRoute>} />
              <Route path="/wfh" element={<PrivateRoute><WFH /></PrivateRoute>} />
              <Route path="/holidays" element={<PrivateRoute><Holidays /></PrivateRoute>} />
              <Route path="/policies" element={<PrivateRoute><Policies /></PrivateRoute>} />
              <Route path="/policies/:id" element={<PrivateRoute><PolicyView /></PrivateRoute>} />
              <Route path="/reimbursements" element={<PrivateRoute><Reimbursement /></PrivateRoute>} />
              <Route path="/overtime" element={<PrivateRoute><Overtime /></PrivateRoute>} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </AppContextProvider>
    </ConfigProvider>
  );
}

export default App;
